import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SpeedTestKillSwitchDropdown from "./SpeedTestKillSwitchDropdown";

export default function Navbar() {
  const [extrasDropdownOpen, setExtrasDropdownOpen] = useState(false);
  const extrasDropdownRef = useRef(null);
  const location = useLocation();

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (extrasDropdownRef.current && !extrasDropdownRef.current.contains(event.target)) {
        setExtrasDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Close dropdown on route change
  useEffect(() => {
    setExtrasDropdownOpen(false);
  }, [location]);

  return (
    <nav className="bg-gray-900 border-b border-gray-700 flex items-center px-6 py-1 relative shadow-md z-10">
      <Link 
        to="/" 
        className={`px-5 py-3 mx-1 text-sm font-medium rounded-t-lg transition-all duration-200 ${
          location.pathname === '/' 
            ? 'bg-white text-gray-900 border-t-2 border-blue-500 shadow-sm' 
            : 'text-gray-300 hover:text-white hover:bg-gray-800'
        }`}
      >
        Home
      </Link>
      <Link 
        to="/comparative-analytics" 
        className={`px-5 py-3 mx-1 text-sm font-medium rounded-t-lg transition-all duration-200 ${
          location.pathname === '/comparative-analytics' 
            ? 'bg-white text-gray-900 border-t-2 border-blue-500 shadow-sm' 
            : 'text-gray-300 hover:text-white hover:bg-gray-800'
        }`}
      >
        Comparative Analytics
      </Link>
      <Link 
        to="/device-info-compact" 
        className={`px-5 py-3 mx-1 text-sm font-medium rounded-t-lg transition-all duration-200 ${
          location.pathname === '/device-info-compact' 
            ? 'bg-white text-gray-900 border-t-2 border-blue-500 shadow-sm' 
            : 'text-gray-300 hover:text-white hover:bg-gray-800'
        }`}
      >
        Android Device Data
      </Link>
      <Link 
        to="/speed-test-audit" 
        className={`px-5 py-3 mx-1 text-sm font-medium rounded-t-lg transition-all duration-200 ${
          location.pathname === '/speed-test-audit' 
            ? 'bg-white text-gray-900 border-t-2 border-blue-500 shadow-sm' 
            : 'text-gray-300 hover:text-white hover:bg-gray-800'
        }`}
      >
        Speed Test Monitor
      </Link>
      <Link 
        to="/HeatMap" 
        className={`px-5 py-3 mx-1 text-sm font-medium rounded-t-lg transition-all duration-200 ${
          location.pathname === '/HeatMap' 
            ? 'bg-white text-gray-900 border-t-2 border-blue-500 shadow-sm' 
            : 'text-gray-300 hover:text-white hover:bg-gray-800'
        }`}
      >
        Signal & Speed Map
      </Link>
      <Link
        to="/yard-travel-map"
        className={`px-5 py-3 mx-1 text-sm font-medium rounded-t-lg transition-all duration-200 ${
          location.pathname === '/yard-travel-map'
            ? 'bg-white text-gray-900 border-t-2 border-blue-500 shadow-sm'
            : 'text-gray-300 hover:text-white hover:bg-gray-800'
        }`}
      >
        Yard Travel Map
      </Link>
      <Link
        to="/speed-test-groups"
        className={`px-5 py-3 mx-1 text-sm font-medium rounded-t-lg transition-all duration-200 ${
          location.pathname === '/speed-test-groups'
            ? 'bg-white text-gray-900 border-t-2 border-blue-500 shadow-sm'
            : 'text-gray-300 hover:text-white hover:bg-gray-800'
        }`}
      >
        Group Test
      </Link>
      <div className="ml-auto flex items-center">
        <SpeedTestKillSwitchDropdown />
        <div className="relative" ref={extrasDropdownRef}>
        <button
          className={`px-5 py-3 mx-1 text-sm font-medium rounded-t-lg transition-all duration-200 focus:outline-none ${
            extrasDropdownOpen 
              ? 'bg-white text-gray-900 border-t-2 border-blue-500 shadow-sm' 
              : 'text-gray-300 hover:text-white hover:bg-gray-800'
          }`}
          onClick={() => setExtrasDropdownOpen((open) => !open)}
        >
          Extras
        </button>
        {extrasDropdownOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-white text-black rounded shadow-lg z-10">
            <Link
              to="/device-outages"
              className="block px-4 py-2 hover:bg-gray-100"
            >
              Device Outages
            </Link>
            <Link
              to="/speedtest-dashboard"
              className="block px-4 py-2 hover:bg-gray-100"
            >
              Speed Test Dashboard
            </Link>
          </div>
        )}
        </div>
      </div>
    </nav>
  );
}
